import compact from 'lodash/compact';
import keyBy from 'lodash/keyBy';

import { Model, Ordenable } from '@/models/Model';

export const reorderGroupedItems = <T extends Model & Ordenable>(
  items: T[],
  groups: Array<{ childIds: number[]; patch?: Partial<T> }>,
): T[] => {
  const itemsById = keyBy(items, 'id');
  return groups.flatMap(({ childIds, patch }) =>
    compact(childIds.map(childId => itemsById[childId])).map((item, index) => ({
      ...item,
      ...patch,
      order: index + 1,
    })),
  );
};
